// **********************************************************
// Sign Up Module
// **********************************************************

attachEvent('.sign-up__form-trigger', 'click', (ev) => {
  const parentElem = ev.target.closest('.sign-up');
  const formEle = parentElem.querySelector('.sign-up__form');
  parentElem.classList.toggle('is-open');
  slideToggle(formEle, 300, 'block');
});
